import { render, staticRenderFns } from "./RequestLetterTaghirAghsat.vue?vue&type=template&id=035cd3b4&scoped=true&"
import script from "./RequestLetterTaghirAghsat.vue?vue&type=script&lang=js&"
export * from "./RequestLetterTaghirAghsat.vue?vue&type=script&lang=js&"
import style0 from "./RequestLetterTaghirAghsat.vue?vue&type=style&index=0&id=035cd3b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035cd3b4",
  null
  
)

export default component.exports